import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  latePaymentFeeDetailsList: { loading: false, data: null, error: null },
  createGenerateInvoice: { loading: false, data: null, error: null },
};
export const latePaymentFeeDetailsSlice = createSlice({
  name: "latePaymentFeeDetails",
  initialState,
  reducers: {
    fetchLatePaymentFeeDetailsListRequest: (state, action) => {
      state.latePaymentFeeDetailsList.loading = true;
      state.latePaymentFeeDetailsList.error = null;
    },
    fetchLatePaymentFeeDetailsListSuccess: (state, action) => {
      state.latePaymentFeeDetailsList.data = action.payload;
      state.latePaymentFeeDetailsList.loading = false;
      state.latePaymentFeeDetailsList.error = null;
    },
    fetchLatePaymentFeeDetailsListFailure: (state, action) => {
      state.latePaymentFeeDetailsList.data = null;
      state.latePaymentFeeDetailsList.loading = false;
      state.latePaymentFeeDetailsList.error = action.payload;
    },
    createGenerateInvoiceRequest: (state, action) => {
      state.createGenerateInvoice.loading = true;
      state.createGenerateInvoice.error = null;
    },
    createGenerateInvoiceSuccess: (state, action) => {
      state.createGenerateInvoice.data = action.payload;
      state.createGenerateInvoice.loading = false;
      state.createGenerateInvoice.error = null;
      state.latePaymentFeeDetailsList= addNewInvoiceSuccess(action.payload, {
        ...state.latePaymentFeeDetailsList,
      });
      
    },
    createGenerateInvoiceFaliure: (state, action) => {
      state.createGenerateInvoice.data = null;
      state.createGenerateInvoice.loading = false;
      state.createGenerateInvoice.error = action.payload;
    },

    resetInvoice: (data, action) => {
      data.createGenerateInvoice.data = null;
      data.createGenerateInvoice.error = null;
      data.createGenerateInvoice.loading = false;
    },





  },
});
function addNewInvoiceSuccess(dataToUpdate, state) {
  state.data.data = [dataToUpdate, ...state.data.data];
  state.data.total++;
  return state;
}
export const {
  fetchLatePaymentFeeDetailsListRequest,
  fetchLatePaymentFeeDetailsListSuccess,
  fetchLatePaymentFeeDetailsListFailure,

  createGenerateInvoiceRequest,
  createGenerateInvoiceSuccess,
  createGenerateInvoiceFaliure,

  resetInvoice,

} = latePaymentFeeDetailsSlice.actions;

export const getLatePaymentFeeDetailsListState = (store) =>
  store.latePaymentFeeDetails?.latePaymentFeeDetailsList;
  export const createGenerateInvoiceState = (store) =>
  store.latePaymentFeeDetails?.createGenerateInvoice;

export default latePaymentFeeDetailsSlice.reducer;
